module.exports = __webpack_public_path__ + "static_pc/img/s02.fd5fa43f.png";